import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";
import { CountryResponseDto } from "./country-dto";

// Response Dto
export interface CityResponseDto extends IEntityWithSoftDeleteDto {
    name: string;
    countryId: string;
    country?: CountryResponseDto;
}

// zod schema
export const cityFormSchema = z
    .object({
        id: z.string().optional(),
        name: z.string().trim().min(1, { message: "Name is required" }),
        countryId: z.string(),
    })
    .required();

// zod infer
export type CityFormDto = z.infer<typeof cityFormSchema>;
